import { render, staticRenderFns } from "./VacationForm.vue?vue&type=template&id=48b807ef&scoped=true&"
import script from "./VacationForm.vue?vue&type=script&lang=js&"
export * from "./VacationForm.vue?vue&type=script&lang=js&"
import style0 from "./VacationForm.vue?vue&type=style&index=0&id=48b807ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b807ef",
  null
  
)

export default component.exports